module.exports = "/_next/static/images/7491bb327325a7284d56d4764ca0daaa-website-thumb-large.jpg.webp";